import { initialWindowType } from '@/hooks/media';
import { Modal } from '@bfe/moly';
import Image from 'next/image';
import styles from './index.module.scss';
import { HOME_POPUP_BONUS_ICON, STEP_LIST_ICON_1_IMG } from '@/constants';
import { Button } from '@/components';
import { useFm } from '@web3/base-hooks';
import { useEffect, useRef } from 'react';
import { scTrack } from '@web3/base-tracking';
import { Event } from '@/config/track-config';
import { LoadingIcon } from '@bfe/moly-icons';

interface Props {
  visible: boolean;
  isLoading: boolean;
  onClose: () => void;
  onConnectWeb3Wallet: () => void;
  onConnectBybitAccount: () => void;
}

const PAGE_NAME = 'JoinPopup';

const LoginModal = ({
  visible,
  isLoading,
  onClose,
  onConnectWeb3Wallet,
  onConnectBybitAccount,
}: Props) => {
  const { isMobile } = initialWindowType;
  const fm = useFm();
  const title = fm('chooseAccountToConnect');
  const listText = fm('connectWalletEarnPointsHit').split('<br/>');
  const clickedBtn = useRef<'WALLET' | 'SPOT'>();

  useEffect(() => {
    if (!visible) return;
    scTrack(Event.Web3PageView, {
      page_name: PAGE_NAME,
    });
  }, [visible]);

  const Footer = () => (
    <div className={styles.footer}>
      <Button
        // className={styles.button}
        variant="primary"
        size={isMobile ? 'small' : 'middle'}
        disabled={isLoading}
        onClick={() => {
          scTrack(Event.Web3UserClick, {
            page_name: PAGE_NAME,
            button_name: 'connectWeb3',
          });
          clickedBtn.current = 'WALLET';
          onConnectWeb3Wallet();
        }}
      >
        {isLoading && clickedBtn.current === 'WALLET' ? (
          <LoadingIcon className={styles.loading} />
        ) : (
          fm('aidolConnectWeb3Wallet')
        )}
      </Button>
      {isMobile && fm('loginModalOr')}
      <Button
        className={styles.button}
        customType="gradient"
        variant="secondaryBrand"
        size={isMobile ? 'small' : 'middle'}
        disabled={isLoading}
        onClick={() => {
          scTrack(Event.Web3UserClick, {
            page_name: PAGE_NAME,
            button_name: 'connectBybit',
          });
          clickedBtn.current = 'SPOT';
          onConnectBybitAccount();
        }}
      >
        {isLoading && clickedBtn.current === 'SPOT' ? (
          <LoadingIcon className={styles.loading} />
        ) : (
          fm('aidolConnectBybitAccount')
        )}
      </Button>
    </div>
  );

  return (
    <Modal
      modal={false}
      className={styles.modal}
      isMobile={isMobile}
      direction={!isMobile ? 'center' : 'bottom'}
      title={!isMobile ? title : ''}
      cancelText={false}
      onCancel={() => {
        onClose?.();
      }}
      open={visible}
      onOpenAutoFocus={(e) => e.preventDefault()}
      contextWrapper={styles.contextWrapper}
      footer={<Footer />}
      footerWrapper={styles.footerWrapper}
    >
      <div className={styles.content}>
        <Image
          className={styles.mainIcon}
          loader={({ src }) => src}
          src={STEP_LIST_ICON_1_IMG}
          width={133}
          height={133}
          alt=""
        />
        {isMobile && <h1>{title}</h1>}
        <ul className={styles.mainText}>
          <li>{listText[0]}</li>
        </ul>
      </div>
    </Modal>
  );
};

export default LoginModal;
